import { Button, FormControl, FormHelperText, Grid, Input, Typography } from "@material-ui/core";
import React, { Component } from "react";
import { handleStateChangeFromProps } from "./helpers";
class StopwatchInput extends Component {
    state = {
        timerOn: false,
        timerStart: 0,
        error: false,
        value: 0,
        enabled: '',
        onChange: null,
        type: 'text',
        name: '',
        title: '',
        width: 12,
        extra: {},
        disabled: false,
        className: '',
        description: '',
        autoComplete: '',
        hidden: false,
    };
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    static getDerivedStateFromProps(nextProps, prevState) {
        return handleStateChangeFromProps(nextProps, prevState)
    }
    startTimer = () => {
        this.setState({
            timerOn: true,
            //value: this.state.value,
            timerStart: Date.now() - this.state.value
        });
        this.timer = setInterval(() => {
            const value = Date.now() - this.state.timerStart;
            this.props.onChange({
                target: {
                    type: 'stopwatch',
                    value: value,
                    name: this.state.name,
                }
            });
            const { seconds, minutes, hours } = this.calculateSegments(value);
            document.title = (hours > 0 ? hours + ':' : '') + (hours > 0 || minutes > 0 ? minutes + ':' : '') + seconds;
        }, 10);
    };
    stopTimer = () => {
        this.setState({ timerOn: false });
        clearInterval(this.timer);
        document.title = 'Create Volunteer Hours Log';
    };
    resetTimer = () => {
        this.setState({
            timerStart: 0,
            //value
        });
        this.props.onChange({
            target: {
                type: 'stopwatch',
                value: 0,
                name: this.state.name,
            }
        });
        document.title = 'Volunteer Log Create';
    };
    componentWillUnmount() {
        clearInterval(this.timer);
        document.title = 'Volunteer Log Create';
    }
    changeTimer = (value, oldValue, type) => {
        if (value < 0 || !value)
            value = 0;
        const currentValue = this.state.value || 0;
        if (value > 99) {
            let newValue = value.replace(oldValue, '$')
            value = parseInt(newValue.replace('$', oldValue.charAt(1)));
        }
        switch (type) {
            case 'hours': {
                value = currentValue - oldValue * 3600000 + value * 3600000;
                break;
            }
            case 'minutes': {
                value = currentValue - oldValue * 60000 + value * 60000;
                break;
            }
            case 'seconds': {
                value = currentValue - oldValue * 1000 + value * 1000;
                break;
            }
            default: { }
        }
        clearInterval(this.timer);
        this.props.onChange({
            target: {
                type: 'stopwatch',
                value: value,
                name: this.state.name,
            }
        });
        this.setState({ timerStart: Date.now() - value },
            function () { this.state.timerOn && this.startTimer() });
    };
    calculateSegments(value) {
        const segments = {};
        segments.seconds = ("0" + (Math.floor(value / 1000) % 60)).slice(-2);
        segments.minutes = ("0" + (Math.floor(value / 60000) % 60)).slice(-2);
        segments.hours = ("0" + Math.floor(value / 3600000)).slice(-2);
        //segments.centiseconds = ("0" + (Math.floor(processedValue / 10) % 100)).slice(-2);
        return segments;
    }
    render() {
        const { error, value, enabled, width,
            className, hidden } = this.state;
        if (hidden) {
            if (typeof (hidden) !== 'function' || hidden())
                return <div />
        }
        let processedValue = value | 0;
        const { seconds, minutes, hours } = this.calculateSegments(processedValue);
        return (
            <Grid item xs={12} sm={width ? width : 12} className={className}>
                <FormControl margin={this.props.margin || "normal"} fullWidth error={error && enabled}>
                    {/*  {description && <Tooltip title={renderStringAsHtml(description)} style={{ alignSelf: 'flex-end' }} placement="top"><HelpRounded fontSize='small' /></Tooltip>}
                    <InputLabel htmlFor={name} {...type && type.indexOf('date') != -1 ? { shrink: true } : {}}>{title} {this.props.required ? '*' : ''}</InputLabel>
                     */}<div>
                        <div style={{ display: 'inline-block', marginRight: 10 }}>
                            <Input
                                value={hours}
                                style={{ width: 43, fontSize: '26pt' }}
                                type='tel'
                                onChange={(e) => this.changeTimer(e.target.value, hours, 'hours')}
                            />
                            <Typography display='inline' style={{ fontSize: '26pt' }}> : </Typography>
                            <Input
                                value={minutes}
                                style={{ width: 43, fontSize: '26pt' }}
                                type='tel'
                                onChange={(e) => this.changeTimer(e.target.value, minutes, 'minutes')}
                            />
                            <Typography display='inline' style={{ fontSize: '26pt' }}> : </Typography>
                            <Input
                                value={seconds}
                                style={{ width: 43, fontSize: '26pt' }}
                                type='tel'
                                onChange={(e) => this.changeTimer(e.target.value, seconds, 'seconds')}
                            />
                            {/*  : {centiseconds} */}
                        </div>
                        {this.state.timerOn === false && processedValue === 0 && (
                            <Button variant='outlined' onClick={this.startTimer}>Start</Button>
                        )}
                        {this.state.timerOn === true && (
                            <Button variant='outlined' onClick={this.stopTimer}>Pause</Button>
                        )}
                        {this.state.timerOn === false && processedValue > 0 && (
                            <Button variant='outlined' onClick={this.startTimer}>Resume</Button>
                        )}
                        {this.state.timerOn === false && processedValue > 0 && (
                            <Button variant='outlined' onClick={this.resetTimer}>Reset</Button>
                        )}
                    </div>
                    {error && enabled ? <FormHelperText>{typeof (error) == 'string' ? error : 'This field is required'}</FormHelperText> : ''}
                </FormControl>
            </Grid>
        );
    }
}
export default StopwatchInput;